<template lang="pug">
    .chart-container.siteviews-chart(v-loading="loading")
        h3.title {{ $t('All Pages Report') }}
        //- template(v-if="runningJobs.length")
        //-     .job
        //-         el-progress(
        //-             :percentage="Math.round(runningJobs[0].percentage * 100) / 100"
        //-             :width="50"
        //-             :show-text="false"
        //-         )
        //-         .summary(v-if="runningJobs[0].percentage && runningJobs[0].current > 0")
        //-             small {{ runningJobs[0].current }} / {{ runningJobs[0].total }}
        //-             small {{ runningJobs[0].percentage.toFixed(2) }}%

        //- transition(name="slide-decent-vertical")
        //-     .status-logs-container.z-depth-1(v-if="logs.length")
        //-         .spinner-container(v-if="loadingLogs")
        //-             .spinner
        //-         StatusLog(v-for="log in logs" :key="log.id" :log="log")
        //-             template(v-if="['success', 'error'].includes(log.status)" slot="actions")
        //-                 a.is-danger(href="#" @click.prevent="hideStatusLog(log)")
        //-                     i.el-icon-fa-times.fas

        .error(v-if="error")
            template(v-if="error.code")
                Error(:message="$t(error.message)" :code="error.code")
            template(v-else)
                Error(:message="$t('Something went wrong!')" :code="501")
        //- line-chart.chart(
        //-     v-else
        //-     ref="chart"
        //-     :chart-data="datacollection"
        //-     :options="chartOptions"
        //- )
        line-chart-extended.chart(
            v-else
            ref="chart"
            :chart-data="datacollection"
            :options="chartOptions"
            :height="400"
        )
        .legend(v-if="!(error && [401, 403].includes(error.code))")
            ul.no-style-list
                li.all-visitors
                    el-button(
                        size="mini"
                        @click="toggleDatasets(['all-visitors'], $event)"
                    )
                        span.color(:style="getLegendStyle('all-visitors')")
                        span.label(:class="{ 'strike-through': disabledDatasets.includes('all-visitors') }")
                            | {{ $t('Unique Visitors') }}
                li.all-views
                    el-button(
                        size="mini"
                        @click="toggleDatasets(['all-pageviews'], $event)"
                    )
                        span.color(:style="getLegendStyle('all-pageviews')")
                        span.label(:class="{ 'strike-through': disabledDatasets.includes('all-pageviews') }")
                            | {{ $t('Siteviews') }}
            template(v-if="(campaigns.length && enabledExtensions.includes('marketing')) || marketplaceCampaign")
                hr
                .campaigns
                    .left
                        el-button-group
                            el-button(
                                size="mini"
                                :icon="campaignVisitorsVisible ? '' : 'el-icon-fa-eye-slash fas'"
                                :type="campaignVisitorsVisible ? 'default' : 'info'"
                                @click="toggleCampaignVisitors"
                            )
                                | {{ $t('Unique Visitors') }}
                            el-button(
                                size="mini"
                                :icon="campaignViewsVisible ? '' : 'el-icon-fa-eye-slash fas'"
                                :type="campaignViewsVisible ? 'define' : 'info'"
                                @click="toggleCampaignViews"
                            )
                                | {{ $t('Siteviews') }}
                    .right
                        ul.no-style-list
                            li.campaign(v-for="campaign in campaigns")
                                el-button(
                                    size="mini"
                                    @click="toggleDatasets([`${campaign.key}:visitors`, `${campaign.key}:views`], $event)"
                                )
                                    span.color(
                                        :class="{ disabled: campaignVisitorsVisible !== true }"
                                        :style="getLegendStyle(`${campaign.key}:visitors`, campaignVisitorsVisible !== true)"
                                    )
                                    span.secondary-color(
                                        :class="{ disabled: campaignViewsVisible !== true }"
                                        :style="getLegendStyle(`${campaign.key}:views`, campaignViewsVisible !== true)"
                                    )
                                    span.label(:class="{ 'strike-through': disabledDatasets.includes(`${campaign.key}:visitors`) || disabledDatasets.includes(`${campaign.key}:views`)}")
                                        | {{ campaign.name }}
                            li.divider(v-if="campaigns.length && marketplaceCampaign")
                            li.campaign(v-if="marketplaceCampaign")
                                el-button(
                                    size="mini"
                                    @click="toggleDatasets(['city-offer-marketplace:visitors', 'city-offer-marketplace:views'], $event)"
                                )
                                    span.color(
                                        :class="{ disabled: campaignVisitorsVisible !== true }"
                                        :style="getLegendStyle('city-offer-marketplace:visitors', campaignVisitorsVisible !== true)"
                                    )
                                    span.secondary-color(
                                        :class="{ disabled: campaignViewsVisible !== true }"
                                        :style="getLegendStyle('city-offer-marketplace:views', campaignViewsVisible !== true)"
                                    )
                                    span.label(:class="{ 'strike-through': disabledDatasets.includes('city-offer-marketplace:visitors') || disabledDatasets.includes('city-offer-marketplace:views')}")
                                        | {{ $t('CityOffer Marketplace') }}
</template>

<i18n>
{
    "de": {
        "CityOffer Marketplace": "CityOffer Marktplatz",
        "All Pages Report": "Aufrufe insgesamt",
        "Siteviews": "Seitenaufrufe",
        "Show Siteviews": "Seitenaufrufe anzeigen",
        "Hide Siteviews": "Seitenaufrufe verbergen",
        "Unique Visitors": "Besucher",
        "Show Visitors": "Besucher anzeigen",
        "Hide Visitors": "Besucher verbergen",
        "Daterange": "Zeitraum",
        "Period": "Intervall",
        "Hourly": "Stündlich",
        "Daily": "Täglich",
        "Weekly": "Wöchentlich",
        "Monthly": "Monatlich",
        "Yearly": "Jährlich",
        "Domain": "Domain",
        "Week": "Kalenderwoche",
        "The summary will be processed asynchronously": "Die Zusammenfassung wird asynchron verarbeitet",
        "You will be notified once the summary is completed": "Sie werden benachrichtigt, sobald die Zusammenfassung abgeschlossen ist"
    }
}
</i18n>

<script>
// 16.11.2024
import Color from 'color'

import StatisticsApi from '@/store/api/statistics';

import compareAsc from 'date-fns/compareAsc';

import isPast from 'date-fns/isPast';

import startOfHour from 'date-fns/startOfHour';
import endOfHour from 'date-fns/endOfHour';

import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';

import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';

import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';

import startOfYear from 'date-fns/startOfYear';
import endOfYear from 'date-fns/endOfYear';

import startOfDecade from 'date-fns/startOfDecade';
import endOfDecade from 'date-fns/endOfDecade';

import getUnixTime from 'date-fns/getUnixTime'
import fromUnixTime from 'date-fns/fromUnixTime'

import addHours from 'date-fns/addHours'
import subHours from 'date-fns/subHours'

import addDays from 'date-fns/addDays'
import subDays from 'date-fns/subDays'

import addWeeks from 'date-fns/addWeeks'
import subWeeks from 'date-fns/subWeeks'

import addMonths from 'date-fns/addMonths'
import subMonths from 'date-fns/subMonths'

import addYears from 'date-fns/addYears'
import subYears from 'date-fns/subYears'

import echo from '@/echo';

import differenceInHours from 'date-fns/differenceInHours'
import differenceInDays from 'date-fns/differenceInDays'
import differenceInWeeks from 'date-fns/differenceInWeeks'
import differenceInMonths from 'date-fns/differenceInMonths'
import differenceInYears from 'date-fns/differenceInYears'

import { adminClient as apolloClient } from '@/store/apollo';
import { formatDate } from '@/filters'
import { useAuthStore, useSetupStore } from '@/stores'
import { appNow, appGetUnixTime, appFromUnixTime } from '@/utils/timezone'

// import StatusLogApi from '@/store/api/system/statusLog';

import LineChart from '@/components/LineChart'
// import StatusLog from '@/views/cms/Dashboard/widgets/logs/Partials/StatusLog';
import LineChartExtended from '@/components/LineChartExtended'
import Error from '@/components/Error';

export default {
    name: 'SiteViewsChart',
    props: {
        domain: {
            type: String,
            required: true,
        },
        daterange: {
            type: Array,
            required: true,
        },
        date: {
            type: Date,
            required: true,
        },
        period: {
            type: String,
            required: true,
        },
    },
    data() {
        const component = this;
        return {
            loading: false,
            error: false,
            right: 'statistics:siteview-summaries',
            windowWidth: undefined,
            datacollection: undefined,
            disabledDatasets: [],
            campaignVisitorsVisible: true,
            campaignViewsVisible: true,
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 1000,
                },
                plugins: {
                    tooltip: {
                        mode: 'nearest',
                        intersect: false,
                    },
                    legend: {
                        display: false,
                        position: 'bottom',
                        align: 'end',
                        labels: {
                            usePointStyle: true,
                        },
                    },
                },
                layout: {
                    padding: {
                        left: 10,
                    },
                },
                scales: {
                    x: {
                        offset: true,
                        grid: {
                            offset: true,
                            drawTicks: true,
                        },
                    },
                    y: {
                        beginAtZero: true,
                        ticks: {
                            precision: 0,
                        },
                        grid: {
                            drawTicks: true,
                        },
                    }
                },
                onHover: (event, elements) => {
                    if (elements.length && component.period !== 'hour') {
                        event.native.target.style.cursor = 'pointer';
                    } else {
                        event.native.target.style.cursor = 'default';
                    }
                },
                onClick: this.handleClick
            },

            // logKeys: ['summarize-siteview-statistics'],
            // loadingLogs: false,
            // logs: [],

            rawData: [],
        }
    },
    components: {
        LineChart,
        // StatusLog,
        LineChartExtended,
        Error,
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            this.chartOptions.animation.duration = 1000
            if (reload) this.refetch();
        },
        // logs(newLogs, oldLogs) {
        //     if (oldLogs.length && ! newLogs.length) {
        //         // WARN: clearStore() is causing errors
        //         apolloClient.clearStore().then(() => {
        //             setTimeout(() => this.refetch(false), 10);
        //         })
        //
        //         // apolloClient.cache.reset()
        //         // this.refetch(false)
        //     }
        // },

        domain(value) {
            if (value) this.refetch();
        },
        daterange(value) {
            if (value) this.refetch();
        },
        date(value) {
            if (value) this.refetch();
        },
        period(value) {
            if (value) this.refetch();
        },
    },
    computed: {
        // jobs() {
        //     return this.allJobs.filter(job => job.type === 'summarize:site-view-statistics')
        // },
        // runningJobs() {
        //     return this.jobs.filter(job => ['running'].includes(job.status) && job.percentage < 100)
        // },
        // pendingJobs() {
        //     return this.jobs.filter(job => ['pending'].includes(job.status))
        // },
        marketplaceCampaignKey() {
            return 'city-offer-marketplace';
        },
        marketplaceCampaign() {
            return _.get(this.activeCms, 'is_business_card', false);
        },
        campaigns() {
            const campaigns = [];
            if (this.rawData && this.rawData.length) {
                this.rawData.forEach(element => {
                    if (!element.campaign_key) return;
                    if (element.campaign_key === this.marketplaceCampaignKey) return;
                    if (!campaigns.find(campaign => campaign.key === element.campaign_key)) {
                        campaigns.push({
                            key: element.campaign_key,
                            name: element.campaign_name,
                        });
                    }
                });
            }
            return campaigns;
        },
        allowedToUpdate() {
            let allowed = true;
            if (! this.isSuperUser && ! this.isOwner) {
                allowed = this.rights.find(right => right.key === this.right && right.permission.update)
            }
            return allowed;
        },
        isSuperUser() {
            return useAuthStore().isSuperUser;
        },
        isOwner() {
            return useAuthStore().isOwner;
        },
        rights() {
            return useAuthStore().rights;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        }
    },
    methods: {
        handleClick(event, elements) {
            if (this.period !== 'hour' && elements && elements.length) {
                const element = elements[0]
                // Chart.js 3: use element.index instead of element._index
                this.$emit('click', element.index)
            }
        },
        refetch(loading = true) {
            this.loading = loading;

            let filters = {
                cms: this.activeCms.id,
                // domain: _.get(this.widget, 'settings.domain') || _.get(this.domainOptions, '0.label'),
                // period: _.get(this.widget, 'settings.period') || 'day',
                // from: _.get(this.widget, 'settings.start') || getUnixTime(startOfDay(new Date)),
                // to: _.get(this.widget, 'settings.end') || getUnixTime(endOfDay(new Date)),
                domain: this.domain,
                period: this.period,
                from: appGetUnixTime(this.daterange[0]),
                to: appGetUnixTime(this.daterange[1]),
            };

            StatisticsApi.fetchSiteviewStatistics(filters)
                .then(data => {
                    this.error = false;

                    this.rawData = data;

                    this.$nextTick(() => {
                        this.generate();
                        if (this.$refs.chart) {
                            this.$refs.chart.renderChart(this.datacollection, this.chartOptions)
                            setTimeout(() => this.chartOptions.animation.duration = 0, 1000);
                        }
                    })
                })
                .catch(err => {
                    this.datacollection = undefined;

                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    switch (code) {
                        case 401:
                            this.error = { code, message: 'Unauthorized' };
                            break;
                        case 403:
                            this.error = { code, message: 'Not Allowed' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                })
                .finally(() => {
                    this.loading = false
                })

        },
        generate() {
            let addMethod;
            let differenceMethod;
            let periodStartMethod;

            let chartStartMethod;
            let chartEndMethod;

            let format = this.$t('yyyy-MM-dd');

            let data = []
            let labels = []

            const from = this.daterange[0]
            const to = this.daterange[1]

            switch (this.period) {
                case 'hour':
                    differenceMethod = differenceInHours;
                    periodStartMethod = startOfHour;
                    chartStartMethod = startOfDay;
                    chartEndMethod = endOfDay;
                    addMethod = addHours;
                    format = 'HH:mm';
                    break;

                case 'week':
                    differenceMethod = differenceInWeeks;
                    periodStartMethod = date => startOfWeek(date, {weekStartsOn: 1});
                    chartStartMethod = startOfMonth;
                    chartEndMethod = endOfMonth;
                    addMethod = addWeeks;
                    format = `'${this.$t('Week')}' ww`;
                    break;

                case 'month':
                    differenceMethod = differenceInMonths;
                    periodStartMethod = startOfMonth;
                    chartStartMethod = startOfYear;
                    chartEndMethod = endOfYear;
                    addMethod = addMonths;
                    format = 'LLLL yyyy';
                    break;

                case 'year':
                    differenceMethod = differenceInYears;
                    periodStartMethod = startOfYear;
                    chartStartMethod = startOfDecade;
                    chartEndMethod = endOfDecade;
                    addMethod = addYears;
                    format = 'yyyy';
                    break;

                default:
                // case 'day':
                    differenceMethod = differenceInDays;
                    periodStartMethod = startOfDay;
                    chartStartMethod = date => startOfWeek(date, {weekStartsOn: 1});
                    chartEndMethod = date => endOfWeek(date, {weekStartsOn: 1});
                    addMethod = addDays;
                    break;
            }

            if (from && to) {
                let current = from;
                while (current <= to) {
                    const label = formatDate(current, format);
                    labels.push(label);

                    // Verwende null statt NaN für spanGaps
                    data.push(null)

                    current = addMethod(current, 1);
                }
            }

            // this.datacollection = {
            //     labels: ['foo', 'bar', 'baz'],
            //     datasets: [
            //         {
            //             key: 'all-visitors',
            //             hidden: this.disabledDatasets.indexOf('all-visitors') >= 0,
            //             label: this.$t('Unique Visitors'),
            //             // borderWidth: 1,
            //             borderColor: 'rgb(190, 21, 33)',
            //             backgroundColor: 'rgba(190, 21, 33, 0.7)',
            //             fill: false,
            //             // borderDash: [10,10],
            //             // lineTension: 0.4,
            //             pointHitRadius: 30,
            //             pointRadius: 3,
            //             pointHoverRadius: 7,
            //             data: [Math.floor(Math.random() * (20 - 2 + 1) + 2)]
            //         },
            //     ],
            // }

            this.datacollection = {
                labels,
                datasets: [
                    {
                        key: 'all-visitors',
                        hidden: this.disabledDatasets.indexOf('all-visitors') >= 0,
                        label: this.$t('Unique Visitors'),
                        // borderWidth: 1,
                        borderColor: 'rgb(0, 0, 0)',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        fill: false,
                        // borderDash: [10,10],
                        // lineTension: 0.4,
                        pointHitRadius: 30,
                        pointRadius: 3,
                        pointHoverRadius: 7,
                        data: _.cloneDeep(data),
                        spanGaps: true,
                    },
                    {
                        key: 'all-pageviews',
                        hidden: this.disabledDatasets.indexOf('all-pageviews') >= 0,
                        label: this.$t('Siteviews'),
                        borderColor: 'rgb(160, 160, 160)',
                        backgroundColor: 'rgba(160, 160, 160, 0.7)',
                        fill: false,
                        // borderDash: [10,10],
                        // lineTension: 0.4,
                        pointHitRadius: 30,
                        pointRadius: 3,
                        pointHoverRadius: 7,
                        data: _.cloneDeep(data),
                        spanGaps: true,
                    },
                    {
                        key: 'city-offer-marketplace:visitors',
                        hidden: this.campaignVisitorsVisible !== true || this.disabledDatasets.indexOf('city-offer-marketplace:visitors') >= 0,
                        label: this.$t('Unique Visitors') + ' (' + this.$t('CityOffer Marketplace') + ')',
                        borderColor: '#be1521',
                        backgroundColor: Color('#be1521').fade(0.3).rgb().string(),
                        fill: false,
                        pointHitRadius: 30,
                        pointRadius: 3,
                        pointHoverRadius: 7,
                        data: _.cloneDeep(data),
                        spanGaps: true,
                    },
                    {
                        key: 'city-offer-marketplace:views',
                        hidden: this.campaignViewsVisible !== true || this.disabledDatasets.indexOf('city-offer-marketplace:views') >= 0,
                        label: this.$t('Siteviews') + ' (' + this.$t('CityOffer Marketplace') + ')',
                        borderColor: '#95c01f',
                        backgroundColor: Color('#95c01f').fade(0.3).rgb().string(),
                        fill: false,
                        pointHitRadius: 30,
                        pointRadius: 3,
                        pointHoverRadius: 7,
                        data: _.cloneDeep(data),
                        spanGaps: true,
                    },
                ],
            }

            const now = differenceMethod(periodStartMethod(appNow()), chartStartMethod(appNow()))
            const chartIsInThePast = isPast(chartEndMethod(this.daterange[1]))

            const siteviews = this.rawData;
            if (siteviews && siteviews.length) {

                let i = 0;
                siteviews.forEach(el => {
                    i = differenceMethod(appFromUnixTime(el.start), periodStartMethod(from))

                    if (el.campaign_key && (el.campaign_key === 'city-offer-marketplace' || this.enabledExtensions.includes('marketing'))) {
                        const hex = _.get(el.campaign, 'color') || '#6b52ef';

                        const visitorsDatasetIndex = this.datacollection.datasets.findIndex(dataset => {
                            return dataset.key === `${el.campaign_key}:visitors`;
                        });

                        if (visitorsDatasetIndex >= 0) {
                            // let visitorsData = this.datacollection.datasets[visitorsDatasetIndex].data[i];
                            // if (visitorsData === undefined || isNaN(visitorsData)) visitorsData = 0;
                            if (this.datacollection.datasets[visitorsDatasetIndex].data[i] === null) {
                                this.datacollection.datasets[visitorsDatasetIndex].data[i] = 0;
                            }
                            this.datacollection.datasets[visitorsDatasetIndex].data[i] += el.visitors;
                        } else {
                            const visitorsDataset = {
                                key: `${el.campaign_key}:visitors`,
                                hidden: this.campaignVisitorsVisible !== true || this.disabledDatasets.indexOf(`${el.campaign_key}:visitors`) >= 0,
                                label:  this.$t('Unique Visitors') + ` (${el.campaign_name})`,
                                borderColor: hex,
                                backgroundColor: Color(hex).fade(0.3).rgb().string(),
                                fill: false,
                                // borderDash: [10,10],
                                // lineTension: 0.4,
                                pointHitRadius: 30,
                                pointRadius: 3,
                                pointHoverRadius: 7,
                                data: _.cloneDeep(data),
                                spanGaps: true,
                            };
                            visitorsDataset.data[i] = el.visitors;
                            this.datacollection.datasets.push(visitorsDataset);
                        }

                        const viewsDatasetIndex = this.datacollection.datasets.findIndex(dataset => {
                            return dataset.key === `${el.campaign_key}:views`;
                        });

                        if (viewsDatasetIndex >= 0) {
                            // let viewsData = this.datacollection.datasets[viewsDatasetIndex].data[i];
                            // if (viewsData === undefined || isNaN(viewsData)) viewsData = 0;
                            if (this.datacollection.datasets[viewsDatasetIndex].data[i] === null) {
                                this.datacollection.datasets[viewsDatasetIndex].data[i] = 0;
                            }
                            this.datacollection.datasets[viewsDatasetIndex].data[i] += el.views;
                        } else {
                            const viewsDataset = {
                                key: `${el.campaign_key}:views`,
                                hidden: this.campaignViewsVisible !== true || this.disabledDatasets.indexOf(`${el.campaign_key}:views`) >= 0,
                                label:  this.$t('Siteviews') + ` (${el.campaign_name})`,
                                borderColor: Color(hex).fade(0.5).rgb().string(),
                                backgroundColor: Color(hex).fade(0.5).fade(0.3).rgb().string(),
                                fill: false,
                                // borderDash: [10,10],
                                // lineTension: 0.4,
                                pointHitRadius: 30,
                                pointRadius: 3,
                                pointHoverRadius: 7,
                                data: _.cloneDeep(data),
                                spanGaps: true,
                            };
                            viewsDataset.data[i] = el.views;
                            this.datacollection.datasets.push(viewsDataset);
                        }
                    }

                    // Hauptdatensätze aktualisieren
                    if (this.datacollection.datasets[0].data[i] === null) {
                        this.datacollection.datasets[0].data[i] = 0;
                    }
                    this.datacollection.datasets[0].data[i] += el.visitors;

                    if (this.datacollection.datasets[1].data[i] === null) {
                        this.datacollection.datasets[1].data[i] = 0;
                    }
                    this.datacollection.datasets[1].data[i] += el.views;
                })

                // fix gaps
                this.datacollection.datasets.forEach((dataset, datasetIndex) => {
                    dataset.data.forEach((el, index) => {
                        if (!el && (chartIsInThePast || index <= now)) {
                            this.datacollection.datasets[datasetIndex].data[index] = 0
                        }
                    })
                })
            } else if (chartIsInThePast) {
                // fill with 0 if chart is in the past and no data is available
                this.datacollection.datasets.forEach((dataset, datasetIndex) => {
                    dataset.data.forEach((el, index) => {
                        this.datacollection.datasets[datasetIndex].data[index] = 0
                    })
                })
            }
        },
        getLegendStyle(key, disabled = false) {
            let style = {};

            if (this.datacollection) {
                const datasets = this.datacollection.datasets || []
                const dataset = datasets.find(el => el.key === key)
                if (disabled) {
                    style['background-color'] = 'rgba(0,0,0, 0.1)'
                    style['border-color'] = 'rgba(0,0,0, 0.15)'
                } else if (dataset) {
                    style['background-color'] = dataset.backgroundColor
                    style['border-color'] = dataset.borderColor
                }
            }

            return style;
        },
        toggleDatasets(keys, event) {
            if (event && (event.ctrlKey || event.metaKey)) {
                if (this.datacollection) {
                    let disabledDatasets = this.datacollection.datasets.map(el => {
                        if (keys.includes(el.key) === false) return el.key;
                    });

                    if (disabledDatasets.filter(key => this.disabledDatasets.includes(key)).length < disabledDatasets.length) {
                        this.disabledDatasets = disabledDatasets;
                    } else {
                        this.disabledDatasets = [];
                    }
                }
            } else {
                keys.forEach(key => {
                    const index = this.disabledDatasets.indexOf(key);
                    if (index >= 0) this.disabledDatasets.splice(index, 1);
                    else this.disabledDatasets.push(key)
                })
            }

            // if (this.datacollection) {
            //     const datasets = this.datacollection.datasets || []
            //     datasets.forEach(el => {
            //         if (this.disabledDatasets.includes(el.key)) el.hidden = true;
            //         else el.hidden = false;
            //     })
            // }

            this.generate();
            if (this.$refs.chart) {
                this.$refs.chart.renderChart(this.datacollection, this.chartOptions)
            }
        },
        toggleCampaignVisitors() {
            this.campaignVisitorsVisible = ! this.campaignVisitorsVisible;

            if (! this.campaignVisitorsVisible && ! this.campaignViewsVisible) this.campaignViewsVisible = true

            this.generate();
            if (this.$refs.chart) {
                this.$refs.chart.renderChart(this.datacollection, this.chartOptions)
            }
        },
        toggleCampaignViews() {
            this.campaignViewsVisible = ! this.campaignViewsVisible;

            if (! this.campaignViewsVisible && ! this.campaignVisitorsVisible) this.campaignVisitorsVisible = true

            this.generate();
            if (this.$refs.chart) {
                this.$refs.chart.renderChart(this.datacollection, this.chartOptions)
            }
        },
        // initializeStatusLogSubscription() {
        //     if (!echo.client) {
        //         setTimeout(() => this.initializeStatusLogSubscription(), 10)
        //     } else {
        //         this.fetchRelatedStatusLogs();
        //
        //         echo.client.private('cms.' + this.activeCms.id)
        //             .listen('.status-log:created', async data => {
        //                 if (data.log && this.logKeys.includes(data.log.key)) {
        //                     // check if log is already in the list
        //                     const exists = this.logs.find(log => parseInt(log.id) === parseInt(data.log.id));
        //
        //                     // if not, fetch it and add it to the list
        //                     if (!exists) {
        //                         const logs = await StatusLogApi.fetchList({
        //                             id: data.log.id,
        //                             cms: parseInt(this.activeCms.id),
        //                             status: ['info'],
        //                             key: this.logKeys,
        //                             hide: false,
        //                         })
        //                         if (logs && logs.length) {
        //                             this.logs = [...logs, ...this.logs]
        //
        //                             // order by created_at timestamp desc
        //                             this.logs = _.orderBy(this.logs, 'created_at', 'desc')
        //                             this.logs = _.uniqBy(this.logs, 'id');
        //                         }
        //                     }
        //                 }
        //             })
        //             .listen('.status-log:updated', async data => {
        //                 if (data.log && this.logKeys.includes(data.log.key)) {
        //                     // find the log in the list
        //                     // and update it
        //                     const index = this.logs.findIndex(log => parseInt(log.id) === parseInt(data.log.id));
        //
        //                     if (index >= 0) {
        //                         // this.$set(this.logs, index, data.log);
        //                         if (data.log.hide) {
        //                             this.logs = this.logs.filter(log => parseInt(log.id) !== parseInt(data.log.id));
        //                         } else {
        //                             this.$set(this.logs[index], 'status', data.log.status);
        //                             this.$set(this.logs[index], 'progress', data.log.progress);
        //                             this.$set(this.logs[index], 'updated_at', data.log.updated_at);
        //                             this.$set(this.logs[index], 'heading', data.log.heading);
        //                             this.$set(this.logs[index], 'body', data.log.body);
        //                             this.$set(this.logs[index], 'data', data.log.data);
        //                             this.$set(this.logs[index], 'hide', data.log.hide);
        //
        //                             if (data.log.status !== 'info') {
        //                                 setTimeout(() => {
        //                                     this.logs = this.logs.filter(log => parseInt(log.id) !== parseInt(data.log.id));
        //                                 }, 3000)
        //                             }
        //                         }
        //                     } else {
        //                         // if not found, fetch it and add it to the list
        //                         const logs = await StatusLogApi.fetchList({
        //                             id: data.log.id,
        //                             cms: parseInt(this.activeCms.id),
        //                             status: ['info'],
        //                             key: this.logKeys,
        //                             hide: false,
        //                         })
        //                         // if (logs && logs.length) {
        //                         //     // find the right place to insert the new log
        //                         //     const i = this.logs.findIndex(log => log.id > data.log.id)
        //                         //     if (i >= 0) this.logs.splice(i, 0, logs[0])
        //                         //     else this.logs.push(logs[0])
        //                         // }
        //                         if (logs && logs.length) {
        //                             this.logs = [...logs, ...this.logs]
        //
        //                             // order by created_at timestamp desc
        //                             this.logs = _.orderBy(this.logs, 'created_at', 'desc')
        //                             this.logs = _.uniqBy(this.logs, 'id');
        //                         }
        //                     }
        //                 }
        //             })
        //     }
        // },
        // fetchRelatedStatusLogs() {
        //     let variables = {
        //         cms: parseInt(this.activeCms.id),
        //         status: ['info'],
        //         key: this.logKeys,
        //         hide: false,
        //         skip: 0,
        //         take: 10,
        //     };
        //
        //     StatusLogApi.fetchList(variables)
        //         .then((logs) => this.logs = logs)
        //         .catch(err => console.error(err));
        // },
        // hideStatusLog(log) {
        //     this.loadingLogs = true;
        //
        //     log = _.cloneDeep(log);
        //     if (log.file) delete log.file
        //     log.hide = true;
        //
        //     StatusLogApi.update(log)
        //         .then(data => {
        //             // remove from list
        //             if (data.hide) {
        //                 this.logs = this.logs.filter(el => el.id !== log.id);
        //             } else {
        //                 this.$notify.error({
        //                     title: this.$t('An error occurred!'),
        //                     message: this.$t('Status log could not be hidden.'),
        //                     iconClass: 'fas el-icon-fa-times',
        //                     position: 'bottom-left',
        //                     customClass: 'dark',
        //                     duration: 8000
        //                 });
        //             }
        //         })
        //         .catch(err => {
        //             console.error(err)
        //             this.$notify.error({
        //                 title: this.$t('An error occurred!'),
        //                 message: this.$t('Status log could not be hidden.'),
        //                 iconClass: 'fas el-icon-fa-times',
        //                 position: 'bottom-left',
        //                 customClass: 'dark',
        //                 duration: 8000
        //             });
        //         })
        //         .finally(() => {
        //             this.loadingLogs = false
        //         });
        // },

        // ...mapMutations({
        //     setWidgetValue: 'dashboard/setWidgetValue'
        // }),
        // ...mapActions({
        //     saveWidget: 'dashboard/saveWidget'
        // })
    },
    mounted () {
        // this.updateWindowWidth();

        this.chartOptions.animation.duration = 1000
        this.refetch();

        // this.initializeStatusLogSubscription();
        // this.fetchRelatedStatusLogs();

        // window.addEventListener('resize', this.updateWindowWidth);

        // echo.client.private('cms.' + state.activeCms.id)
        //     .listen('.job:updated', data => {
        //         // if (data.job && ['export:stock'].includes(data.job.type)) {
        //         //     commit('updateUnfinishedJob', data.job);
        //         // }
        //     })
    },
    beforeDestroy() {
        // window.removeEventListener('resize', this.updateWindowWidth);

        // echo.client.private(`cms.${this.activeCms.id}`)
        //     .stopListening('.job:updated')

        // if (echo.client) {
        //     echo.client.private(`cms.${this.activeCms.id}`)
        //         .stopListening('.status-log:created')
        //         .stopListening('.status-log:updated')
        // }
    },
}
</script>

<style lang="sass" scoped>
form.el-form.filters.el-form--inline
    display: flex
    justify-content: space-between
    flex-wrap: wrap
.title
    margin: 0
    margin-bottom: 1rem
    // text-align: center
    font-weight: 300

.chart-container
    display: flex
    flex-direction: column
    .chart
        flex-grow: 1
    &:hover
        .prev, .next
            opacity: 1
            transform: scale(1)

.chart-container-disabled
    display: flex
    flex-direction: column
    flex-grow: 1
    p.body
        flex-grow: 1
        display: flex
        justify-content: center
        align-items: center
        font-size: 2rem
        font-weight: 200
        color: #c3c3c3

.force-update-icon
    font-size: 0.8em

// .status-logs-container
//     margin-top: 0
//     margin-bottom: 1rem

.no-data
    flex-grow: 1
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    padding: 4rem
    text-align: center
    i
        font-size: 4rem
        color: rgba(0,0,0,0.2)
    h4
        margin-top: 1rem
        margin-bottom: 0
        font-size: 2rem
        font-weight: 300
        color: rgba(0,0,0,0.3)

.legend
    display: flex
    flex-direction: column
    align-items: flex-end
    position: relative
    .row
        display: flex
        justify-content: space-between
        align-items: center
        width: 100%
    hr
        width: 100%
        background: none
        border: 1px solid $--border-color-base
        border-bottom: none
    .campaigns
        width: 100%
        display: flex
        justify-content: space-between
    ul
        display: flex
        flex-wrap: wrap
        justify-content: flex-end
        li.divider
            width: 1px
            background: $--border-color-base
            margin: 4px 6px
        li
            &.campaign .el-button
                span.secondary-color
                    opacity: 1
                    display: inline-block
                    position: absolute
                    width: 12px
                    height: 12px
                    top: 11px
                    left: 16px
                    border-radius: 50%
                    // border: 1px solid
                    outline: 1px solid #ffffff
                    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.07), 0 1px 7px 0 rgba(0, 0, 0, 0.06), 0 3px 1px -1px rgba(0, 0, 0, 0.1)
                span.color:after
                    content: ''
                    position: absolute
                    background: white
                    top: 6px
                    left: 10px
                    width: 14px
                    height: 14px
                    border-radius: 50%
            .el-button
                position: relative
                padding-right: 10px
                padding-left: 30px
                border:  none
                background: none !important
                span.color
                    display: inline-block
                    position: absolute
                    width: 18px
                    height: 18px
                    left: 5px
                    top: 4px
                    border-radius: 50%
                    // border: 2px solid
                    outline: 1px solid #ffffff
                    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2)
                span.label.strike-through
                    text-decoration: line-through
                    text-decoration-thickness: 2px

.el-button::v-deep i
    width: 15px

.error
    padding: 20px
    flex-grow: 1
    ::v-deep .title
        margin-top: 0
.title
    position: relative
span.spinner
    position: absolute
    display: inline-block
    width: 24px
    height: 24px
    right: 0
    top: 0
.job
    .summary
        display: flex
        justify-content: space-between
</style>
